export default {
    modules: {
        chat: true,
        inbox: true,
        medical: false,
        symptom: false,
        healhtips: false,
        profile: true,
        documents: false,
        emergency: false
    },
    practitioner: {
        type: 'lawyer',
        plural_type: 'lawyers',
    },
    app: {
        name: 'Free Legal',
        endpoint: 'https://medi4u.co.za/freelegal/'
    },
    registration: {
        simple: true,
        free: true
    },
    location: false,
    share: {
        message: 'For free legal advice, download this great app: https://www.freelegal.co.za/app/link',
        title: "Free Legal Chat 24/7"
    }
}